<template>
  <div :class="$mq" class="frame">
    <h1>{{ $t('Comeback.InvoiceSettings.title') }}</h1>
    <ul class="data two-columns-inline">
      <li><span class="bold">{{ $t('Comeback.InvoiceSettings.invoiceMode') }}</span>
        {{ $t(`Comeback.InvoiceSettings.invoiceModes.${invoicing.mode}`) }}
      </li>

      <li v-if="showInvoicingAddress"><span class="bold">{{ $t('Comeback.InvoiceSettings.invoiceAddress') }}</span>
        {{ invoicingAddress }}
      </li>

      <li v-if="showEmail"><span class="bold">{{ $t('Comeback.InvoiceSettings.invoiceEmail') }}</span>
        {{ invoicing.email }}
      </li>
    </ul>

    <ul class="data two-columns-inline">
      <li><span class="bold">{{ $t('Comeback.InvoiceSettings.paymentMode') }}</span>
        {{ $t(`Comeback.InvoiceSettings.paymentModes.${invoicing.paymentModeCode}`) }}
      </li>

      <li v-if="invoicing.iban"><span class="bold">{{ $t('Comeback.InvoiceSettings.iban') }}</span>
        {{ (invoicing.iban).toUpperCase() }}
      </li>
    </ul>

    <ul class="data two-columns-inline">
      <li><span class="bold">{{ $t('Comeback.InvoiceSettings.paymentFrequency') }}</span>
        {{ $t(`Comeback.InvoiceSettings.paymentFrequencies.${invoicing.paymentFrequency}`) }}
      </li>

      <li v-if="showReceiveInstallment"><span class="bold">{{
          $t('Comeback.InvoiceSettings.receiveInstallment')
        }}</span>
        {{
          invoicing.receiveInstalment === 'true' ? $t('Comeback.InvoiceSettings.yes') : $t('Comeback.InvoiceSettings.no')
        }}
      </li>

      <li></li>
      <li v-if="invoicing.paymentModeCode === 'directDebit'"><span
          class="bold">{{ $t('Comeback.InvoiceSettings.partialDom') }}</span>
        {{ customer.partialDom === 'true' ? $t('Comeback.InvoiceSettings.yes') : $t('Comeback.InvoiceSettings.no') }}
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "InvoiceSettings",
  computed: {
    ...mapState('comeback', ['customer', 'contracts']),
    invoicing() {
      return this.contracts[0].invoicing;
    },
    contract() {
      return this.contracts[0];
    },
    showEmail() {
      if (this.invoicing.mode === 'email') {
        return this.invoicing.email ? this.invoicing.email : this.customer.email;
      }
      return false;
    },
    showReceiveInstallment() {
      return this.invoicing.mode === 'post' && this.contract.paymentModeCode === 'directDebit'
    },
    notSameAddresses() {
      // compare addresses, contracts' deliveryStreetNumber contains postBox
      const contactAddress = (this.customer.address.street + this.customer.address.number + (this.customer.address.box ? '-' + this.customer.address.box : '') + this.customer.address.postCode).toUpperCase();
      const deliveryAddress = (this.contract.delivery.street + this.contract.delivery.number + this.contract.delivery.postCode).toUpperCase();
      return contactAddress !== deliveryAddress;
    },
    invoicingAddress() {
      let invoicingAddress = null;

      if (this.notSameAddresses) {
        invoicingAddress = this.customer.address.street + ' ' + this.customer.address.number;
        invoicingAddress += this.customer.address.box ? ' - ' + this.customer.address.box + ', ' : ', ';
        invoicingAddress += this.customer.address.postCode + ' ' + this.customer.address.town + '.';
      }

      if (this.invoicing.street !== '') {
        invoicingAddress = this.invoicing.street + ' ' + this.invoicing.number;
        invoicingAddress += this.invoicing.box ? ' - ' + this.invoicing.box + ', ' : ', ';
        invoicingAddress += this.invoicing.postCode + ' ' + this.invoicing.town + '.';
      }

      return invoicingAddress;
    },
    showInvoicingAddress() {
      return this.invoicing.mode === 'post' && this.invoicingAddress !== null;
    }
  },
}
</script>

<style scoped>
.two-columns-inline {
  display: grid;
  grid-template-columns: 50% 50%;
}
.frame ul.data.two-columns-inline {
  margin-bottom: 1rem;
}
.frame ul.data.two-columns-inline:last-child {
  margin-bottom: 0;
}

#email:empty::before {
  content: '.';
  visibility: hidden;
}

.bold {
  font-weight: bold;
}

p {
  text-align: left;
}

h3 {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Comeback/ColdLoss/InvoiceSettings.vue